import { useRef, useEffect } from 'react';

export const InputRange = ({ value, setValue, ...props }) => {
    const rangeRef = useRef(null);

    useEffect(() => {
        if(!rangeRef.current) return;
        if(value === 0){
            rangeRef.current.style.backgroundSize = '0, 100%';
        }
        else{
            const min = rangeRef.current.min;
            const max = rangeRef.current.max;
            const val = rangeRef.current.value;
            rangeRef.current.style.backgroundSize = ((val - min) * 100) / (max - min) + '% 100%';
        }
    }, [rangeRef, value])

    return (
        <input
            type="range"
            value={value}
            onChange={(e) => setValue(parseInt(e.target.value))}
            ref={rangeRef}
            {...props}
        />
    );
};
